
export default function (Component) {
  Component.options.__source = "src/components/Flowable/nodeWrap.vue"
}
